<template lang="pug">
.change-status-modal
  b-modal(v-model="_value" :size="size" @ok="ok" @cancel="cancel" no-close-on-backdrop no-close-on-esc)
    div(slot="modal-title")
      span {{ title }}
    
    .d-flex.flex-column
      .d-flex.flex-row.align-items-center.mb-2
        span 変更後のステップ：
        b-form-select.status-select(v-model="_changedStatus" :options="options" style="width: 280px;")
      .error-messages
        .error-message {{ errorMessage }}

    .error-messages(v-if="statusErrorMessage")
        .error-message {{ statusErrorMessage }}

    template(#modal-footer="{ ok, cancel }" style="width:100%;")
      .buttons.d-flex.justify-content-end
        button.btn.modal-ok-btn(type="button" @click="ok()") {{ okButtonLabel }}
        button.btn.modal-cancel-btn(type="button" @click="cancel()") {{ cancelButtonLabel }}
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";

import { ResidentStatus } from "@/commons/services/Residents";
import RoomsService from "@/commons/services/Rooms";
import ResidentGroupsService from "@/commons/services/ResidentGroups";

import FormInput from "@/pc/components/forms/FormInput.vue";
import FormInputSelect from "@/pc/components/forms/FormInputSelect.vue";
import FormDatetimePicker from "@/pc/components/forms/FormDatetimePicker.vue";
import FormTimePicker from "@/pc/components/forms/FormTimePicker.vue";

/**
 * ### OK/キャンセルモーダル
 */
@Component({
  components: {
    FormInput,
    FormInputSelect,
    FormDatetimePicker,
    FormTimePicker
  }
})
export default class ChangeStatusModal extends Vue {
  /** 部屋サービス */
  @Inject("RoomsService") roomsService!: RoomsService;
  /** 利用者グループサービス */
  @Inject("ResidentGroupsService") residentGroupsService!: ResidentGroupsService;

  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** タイトル */
  @Prop({ required: true })
  title!: string;
  /** モーダルサイズ */
  @Prop({ default: () => "lg" })
  size!: string;
  /** OKボタンラベル */
  @Prop({ default: () => "更新" })
  okButtonLabel!: string;
  /** キャンセルボタンラベル */
  @Prop({ default: () => "キャンセル" })
  cancelButtonLabel!: string;

  /** 変更後の状態 */
  @Prop()
  changedStatus!: ResidentStatus;
  /** ステータス変更によるエラーメッセージ */
  @Prop()
  statusErrorMessage!: string;

  /** 利用者状態選択肢 */
  options: Array<{ text: string; value: ResidentStatus }> = [
    { text: "ステップをお選びください", value: ResidentStatus.UNKNOWN },
    { text: "入所申込み", value: ResidentStatus.APPLICATION },
    { text: "申込み受理", value: ResidentStatus.RECEIVED_APPLICATION },
    { text: "判定済", value: ResidentStatus.COMPLETE_APPLICATION },
    { text: "入所意向確認", value: ResidentStatus.CONFIRM_ADMISSION },
    { text: "最終判定中", value: ResidentStatus.FINAL_JUDGE },
    { text: "最終判定済", value: ResidentStatus.COMPLETE_FINAL_JUDGE },
    { text: "入所手続き", value: ResidentStatus.ADMISSION_PROCEDURE }
    // { text: "取り下げ", value: ResidentStatus.CANCELED }
  ];

  errorMessage: string = "";

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _changedStatus(): ResidentStatus {
    return this.changedStatus;
  }

  set _changedStatus(newValue: ResidentStatus) {
    this.$emit("update:changedStatus", newValue);
    return;
  }

  /**
   * ### 状態と状態名を変換する
   */
  public convertStatusName(status: ResidentStatus): string {
    let statusName: string = "";

    switch (status) {
      case ResidentStatus.REGISTERD:
        statusName = "登録者";
        break;
      case ResidentStatus.CANCELED:
        statusName = "取り下げ";
        break;
      case ResidentStatus.TEMPORARILY:
        statusName = "一時保存";
        break;
      case ResidentStatus.APPLICATION:
        statusName = "入所申込み";
        break;
      case ResidentStatus.RECEIVED_APPLICATION:
        statusName = "申込み受理";
        break;
      case ResidentStatus.COMPLETE_APPLICATION:
        statusName = "判定済";
        break;
      case ResidentStatus.CONFIRM_ADMISSION:
        statusName = "入所意向確認";
        break;
      case ResidentStatus.FINAL_JUDGE:
        statusName = "最終判定中";
        break;
      case ResidentStatus.COMPLETE_FINAL_JUDGE:
        statusName = "最終判定済";
        break;
      case ResidentStatus.ADMISSION_PROCEDURE:
        statusName = "入所手続き";
        break;
      case ResidentStatus.RESIDENT:
        statusName = "利用者";
        break;
      default:
        statusName = "";
        break;
    }

    return statusName;
  }

  public async ok(bvModalEvent: any): Promise<void> {
    bvModalEvent.preventDefault();

    // 変更後ステップが未入力の場合エラーとして扱う
    if (this.changedStatus == ResidentStatus.UNKNOWN) {
      this.errorMessage = "変更後のステップを選択してください";
    } else {
      this.$emit("ok", null);
    }

    return;
  }

  public cancel(): void {
    this.$emit("cancel");
    return;
  }
}

export interface TargetFacility {
  /** 施設ID */
  id: number;
  /** 施設名 */
  name: string;
  /** 利用者ID */
  residentId: number;
  /** 選択したか否か */
  checked: boolean;
}
</script>
